import System from 'system'

const emojisPath = `${System.url}/emojis/`

const CUSTOM_EMOJIS = [
  {
    id: 'comunidad',
    emojis: [
      {
        id: '1up',
        keywords: ['vida'],
        name: '1 up',
        skins: [{ src: `${emojisPath}1up.png` }],
      },
      {
        id: '2cents',
        keywords: [],
        name: '2 centavos',
        skins: [{ src: `${emojisPath}2cents.jpg` }],
      },
      {
        id: '1000',
        keywords: ['mil'],
        name: '1000',
        skins: [{ src: `${emojisPath}1000.png` }],
      },
      {
        id: 'alf',
        keywords: [],
        name: 'Alf',
        skins: [{ src: `${emojisPath}alf.png` }],
      },
      {
        id: 'allthethings',
        keywords: ['todo'],
        name: 'Todas las cosas',
        skins: [{ src: `${emojisPath}allthethings.png` }],
      },
      {
        id: 'amen',
        keywords: [],
        name: 'Amén',
        skins: [{ src: `${emojisPath}amen.png` }],
      },
      {
        id: 'arm-flap',
        keywords: [],
        name: 'Flotando',
        skins: [{ src: `${emojisPath}arm-flap.gif` }],
      },
      {
        id: 'at',
        keywords: [],
        name: '@',
        skins: [{ src: `${emojisPath}at.png` }],
      },
      {
        id: 'attitude',
        keywords: [],
        name: 'Actitud',
        skins: [{ src: `${emojisPath}attitude.png` }],
      },
      {
        id: 'aw-yeah',
        keywords: [],
        name: 'Aw Yeah!',
        skins: [{ src: `${emojisPath}aw_yeah.gif` }],
      },
      {
        id: 'awesome-epic-smile',
        keywords: [],
        name: 'Sonrisa épica',
        skins: [{ src: `${emojisPath}awesome-epic-smile.png` }],
      },
      {
        id: 'awesome-epic-smile-party',
        keywords: [],
        name: 'Sonrisa épica - Fiesta',
        skins: [{ src: `${emojisPath}awesome-epic-smile-party.gif` }],
      },
      {
        id: 'bandit',
        keywords: [],
        name: 'Bandido',
        skins: [{ src: `${emojisPath}bandit.gif` }],
      },
      {
        id: 'banana_dance',
        keywords: [],
        name: 'Baile de Banana',
        skins: [{ src: `${emojisPath}banana_dance.gif` }],
      },
      {
        id: 'bartman',
        keywords: [],
        name: 'Bartman',
        skins: [{ src: `${emojisPath}bartman.png` }],
      },
      {
        id: 'bbq',
        keywords: [],
        name: 'BBQ',
        skins: [{ src: `${emojisPath}bbq.png` }],
      },
      {
        id: 'bender-dance',
        keywords: [],
        name: 'Bender - Baile',
        skins: [{ src: `${emojisPath}bender-dance.gif` }],
      },
      {
        id: 'bender',
        keywords: [],
        name: 'Bender',
        skins: [{ src: `${emojisPath}bender.jpg` }],
      },
      {
        id: 'bob-ross',
        keywords: [],
        name: 'Bob Ross',
        skins: [{ src: `${emojisPath}bob-ross.png` }],
      },
      {
        id: 'bored-cat',
        keywords: [],
        name: 'Gato aburrido',
        skins: [{ src: `${emojisPath}bored-cat.gif` }],
      },
      {
        id: 'bossbaby',
        keywords: ['jefe', 'bebe', 'bebé'],
        name: 'Boss Baby',
        skins: [{ src: `${emojisPath}bossbaby.jpg` }],
      },
      {
        id: 'boxinggloves',
        keywords: ['guantes', 'boxeo'],
        name: 'boxinggloves',
        skins: [{ src: `${emojisPath}boxinggloves.png` }],
      },
      {
        id: 'bug2',
        keywords: ['bug', 'bicho'],
        name: 'Bug',
        skins: [{ src: `${emojisPath}bug2.gif` }],
      },
      {
        id: 'bunny',
        keywords: ['conejo'],
        name: 'Conejo',
        skins: [{ src: `${emojisPath}bunny.gif` }],
      },
      {
        id: 'burger',
        keywords: [],
        name: 'Hamburguesa',
        skins: [{ src: `${emojisPath}burger.png` }],
      },
      {
        id: 'carlton',
        keywords: ['dance'],
        name: 'Carlton - Baile',
        skins: [{ src: `${emojisPath}carlton.gif` }],
      },
      {
        id: 'caveman',
        keywords: [],
        name: 'Cavernícola',
        skins: [{ src: `${emojisPath}caveman.png` }],
      },
      {
        id: 'challengeaccepted',
        keywords: [],
        name: 'Desafío Aceptado',
        skins: [{ src: `${emojisPath}challengeaccepted.png` }],
      },
      {
        id: 'christmas-groan',
        keywords: [],
        name: 'Gemido de navidad',
        skins: [{ src: `${emojisPath}christmas-groan.png` }],
      },
      {
        id: 'christmas-shiftyeyes',
        keywords: [],
        name: 'Mirada furtiva de navidad',
        skins: [{ src: `${emojisPath}christmas-shiftyeyes.gif` }],
      },
      {
        id: 'cletus',
        keywords: [],
        name: 'Cletus',
        skins: [{ src: `${emojisPath}cletus.jpg` }],
      },
      {
        id: 'code',
        keywords: ['codigo'],
        name: 'Código',
        skins: [{ src: `${emojisPath}code.png` }],
      },
      {
        id: 'coffee-parrot',
        keywords: ['cafe', 'dance', 'baile'],
        name: 'Perico con café bailando',
        skins: [{ src: `${emojisPath}coffee-parrot.gif` }],
      },
      {
        id: 'comicbookguy',
        keywords: [],
        name: 'Chico de los cómics',
        skins: [{ src: `${emojisPath}comicbookguy.jpg` }],
      },
      {
        id: 'cookiemonster',
        keywords: [],
        name: 'Monstruo comegalletas',
        skins: [{ src: `${emojisPath}cookiemonster.png` }],
      },
      {
        id: 'coolio',
        keywords: [],
        name: 'Coolio',
        skins: [{ src: `${emojisPath}coolio.gif` }],
      },
      {
        id: 'cry_happy',
        keywords: [],
        name: 'Llora de felicidad',
        skins: [{ src: `${emojisPath}cry_happy.png` }],
      },
      {
        id: 'cry_proud',
        keywords: [],
        name: 'Llora de orgullo',
        skins: [{ src: `${emojisPath}cry_proud.png` }],
      },
      {
        id: 'crying-dance',
        keywords: [],
        name: 'Llora y baila',
        skins: [{ src: `${emojisPath}crying-dance.gif` }],
      },
      {
        id: 'danceparrot',
        keywords: [],
        name: 'Perico que baila',
        skins: [{ src: `${emojisPath}danceparrot.gif` }],
      },
      {
        id: 'dancing_panda',
        keywords: [],
        name: 'Panda que baila',
        skins: [{ src: `${emojisPath}dancing_panda.gif` }],
      },
      {
        id: 'dancing-chicken',
        keywords: [],
        name: 'Pollo que baila',
        skins: [{ src: `${emojisPath}dancing-chicken.gif` }],
      },
      {
        id: 'doggy',
        keywords: ['perro'],
        name: 'Cachorro',
        skins: [{ src: `${emojisPath}doggy.gif` }],
      },
      {
        id: 'doh',
        keywords: [],
        name: 'Homero - Doh',
        skins: [{ src: `${emojisPath}doh.png` }],
      },
      {
        id: 'drool',
        keywords: [],
        name: 'Homero - Babea',
        skins: [{ src: `${emojisPath}drool.gif` }],
      },
      {
        id: 'epic-win',
        keywords: ['triunfo', 'épico'],
        name: 'Epic Win',
        skins: [{ src: `${emojisPath}epic_win.png` }],
      },
      {
        id: 'evil-laugh-fox',
        keywords: [],
        name: 'Zorro - Risa malvada',
        skins: [{ src: `${emojisPath}evil-laugh-fox.gif` }],
      },
      {
        id: 'excite',
        keywords: [],
        name: 'Emocionado',
        skins: [{ src: `${emojisPath}excite.gif` }],
      },
      {
        id: 'excited-cat',
        keywords: [],
        name: 'Gato - Emocionado',
        skins: [{ src: `${emojisPath}excited-cat.gif` }],
      },
      {
        id: 'excited',
        keywords: [],
        name: 'Dragon - Emocionado',
        skins: [{ src: `${emojisPath}excited.gif` }],
      },
      {
        id: 'extra',
        keywords: [],
        name: 'EXTRA',
        skins: [{ src: `${emojisPath}extra.jpg` }],
      },
      {
        id: 'eyetwitch',
        keywords: [],
        name: 'Tic nervioso',
        skins: [{ src: `${emojisPath}eyetwitch.gif` }],
      },
      {
        id: 'facepalm',
        keywords: [],
        name: 'Palmada en la cara',
        skins: [{ src: `${emojisPath}facepalm.png` }],
      },
      {
        id: 'fade',
        keywords: [],
        name: 'Homero - Desaparece',
        skins: [{ src: `${emojisPath}fade.gif` }],
      },
      {
        id: 'fadein',
        keywords: [],
        name: 'Homero - Aparece',
        skins: [{ src: `${emojisPath}fadein.gif` }],
      },
      {
        id: 'fancy-pinky',
        keywords: [],
        name: 'Dedo - Elegante',
        skins: [{ src: `${emojisPath}fancy-pinky.png` }],
      },
      {
        id: 'fancy',
        keywords: [],
        name: 'Elegante',
        skins: [{ src: `${emojisPath}fancy.gif` }],
      },
      {
        id: 'feelbetter',
        keywords: [],
        name: 'Mejórate pronto',
        skins: [{ src: `${emojisPath}feelbetter.jpg` }],
      },
      {
        id: 'feelin-good',
        keywords: [],
        name: 'Sintiéndose bien',
        skins: [{ src: `${emojisPath}feelin-good.gif` }],
      },
      {
        id: 'feelin-real-good',
        keywords: [],
        name: 'Sintiéndose muy bien',
        skins: [{ src: `${emojisPath}feelin-real-good.gif` }],
      },
      {
        id: 'fight',
        keywords: ['tabla'],
        name: 'Pelea',
        skins: [{ src: `${emojisPath}fight.gif` }],
      },
      {
        id: 'flanders',
        keywords: [],
        name: 'Flanders',
        skins: [{ src: `${emojisPath}flanders.png` }],
      },
      {
        id: 'flirtycat',
        keywords: [],
        name: 'Gato - Coqueto',
        skins: [{ src: `${emojisPath}flirtycat.gif` }],
      },
      {
        id: 'foreveralone',
        keywords: [],
        name: 'Forever alone',
        skins: [{ src: `${emojisPath}foreveralone.png` }],
      },
      {
        id: 'fozzie',
        keywords: [],
        name: 'fozzie',
        skins: [{ src: `${emojisPath}fozzie.png` }],
      },
      {
        id: 'fry',
        keywords: [],
        name: 'Fry',
        skins: [{ src: `${emojisPath}fry.png` }],
      },
      {
        id: 'gasp',
        keywords: [],
        name: 'Jadeo',
        skins: [{ src: `${emojisPath}gasp.png` }],
      },
      {
        id: 'gent',
        keywords: ['gentleman'],
        name: 'Caballero',
        skins: [{ src: `${emojisPath}gent.png` }],
      },
      {
        id: 'ghostbusters',
        keywords: [],
        name: 'Caza fantasmas',
        skins: [{ src: `${emojisPath}ghostbusters.jpg` }],
      },
      {
        id: 'glare',
        keywords: [],
        name: 'Mirada penetrante',
        skins: [{ src: `${emojisPath}glare.jpg` }],
      },
      {
        id: 'good-night',
        keywords: [],
        name: 'Buenas noches',
        skins: [{ src: `${emojisPath}good-night.gif` }],
      },
      {
        id: 'good-vibes',
        keywords: [],
        name: 'Buenas vibras',
        skins: [{ src: `${emojisPath}good-vibes.gif` }],
      },
      {
        id: 'gottarun',
        keywords: [],
        name: 'Hay que correr',
        skins: [{ src: `${emojisPath}gottarun.gif` }],
      },
      {
        id: 'groan',
        keywords: [],
        name: 'Gemido',
        skins: [{ src: `${emojisPath}groan.png` }],
      },
      {
        id: 'hakuna-matata',
        keywords: [],
        name: 'Hakuna Matata',
        skins: [{ src: `${emojisPath}hakuna-matata.png` }],
      },
      {
        id: 'headphones-on',
        keywords: [],
        name: 'Audífonos',
        skins: [{ src: `${emojisPath}headphones-on.gif` }],
      },
      {
        id: 'headwall',
        keywords: [],
        name: 'Contra el muro',
        skins: [{ src: `${emojisPath}headwall.gif` }],
      },
      {
        id: 'hides',
        keywords: [],
        name: 'Esconderse',
        skins: [{ src: `${emojisPath}hides.gif` }],
      },
      {
        id: 'high5',
        keywords: [],
        name: 'High 5',
        skins: [{ src: `${emojisPath}high5.png` }],
      },
      {
        id: 'hmmm',
        keywords: [],
        name: 'Hmmm',
        skins: [{ src: `${emojisPath}hmmm.png` }],
      },
      {
        id: 'hobbes',
        keywords: [],
        name: 'Hobbes',
        skins: [{ src: `${emojisPath}hobbes.png` }],
      },
      {
        id: 'homer_nerd',
        keywords: [],
        name: 'Homero - Nerd',
        skins: [{ src: `${emojisPath}homer_nerd.png` }],
      },
      {
        id: 'homer-thinking',
        keywords: [],
        name: 'Homero - Pensando',
        skins: [{ src: `${emojisPath}homer-thinking.png` }],
      },
      {
        id: 'housekeeping',
        keywords: [],
        name: 'Aseo',
        skins: [{ src: `${emojisPath}housekeeping.png` }],
      },
      {
        id: 'iseewhatyoudidthere',
        keywords: [],
        name: 'Ya veo',
        skins: [{ src: `${emojisPath}iseewhatyoudidthere.png` }],
      },
      {
        id: 'itembanks',
        keywords: [],
        name: 'Ahorro',
        skins: [{ src: `${emojisPath}itembanks.png` }],
      },
      {
        id: 'jackie_chan',
        keywords: ['que', 'what'],
        name: 'Jackie Chan - What',
        skins: [{ src: `${emojisPath}jackie_chan.png` }],
      },
      {
        id: 'jenkins',
        keywords: [],
        name: 'Jenkins',
        skins: [{ src: `${emojisPath}jenkins.png` }],
      },
      {
        id: 'jordan',
        keywords: ['mj'],
        name: 'Jordan',
        skins: [{ src: `${emojisPath}jordan.png` }],
      },
      {
        id: 'kermit',
        keywords: [],
        name: 'Rana René',
        skins: [{ src: `${emojisPath}kermit.png` }],
      },
      {
        id: 'lol-this',
        keywords: [],
        name: 'Esto ^ lol',
        skins: [{ src: `${emojisPath}lol-this.png` }],
      },
      {
        id: 'lol',
        keywords: [],
        name: 'lol',
        skins: [{ src: `${emojisPath}lol.png` }],
      },
      {
        id: 'lolpanda',
        keywords: [],
        name: 'Panda - lol',
        skins: [{ src: `${emojisPath}lolpanda.gif` }],
      },
      {
        id: 'lookslikewegotabadassoverhere',
        keywords: [],
        name: 'Qué haremos...',
        skins: [{ src: `${emojisPath}lookslikewegotabadassoverhere.jpg` }],
      },
      {
        id: 'mad',
        keywords: [],
        name: 'MAD',
        skins: [{ src: `${emojisPath}mad.png` }],
      },
      {
        id: 'madpanda',
        keywords: [],
        name: 'Panda - Furioso',
        skins: [{ src: `${emojisPath}madpanda.gif` }],
      },
      {
        id: 'mario_luigi_dance',
        keywords: [],
        name: 'Mario y Luigi - Baile',
        skins: [{ src: `${emojisPath}mario_luigi_dance.gif` }],
      },
      {
        id: 'megaman',
        keywords: [],
        name: 'Megaman',
        skins: [{ src: `${emojisPath}megaman.gif` }],
      },
      {
        id: 'milhouse',
        keywords: [],
        name: 'Milhouse',
        skins: [{ src: `${emojisPath}milhouse.png` }],
      },
      {
        id: 'miracle-worker',
        keywords: [],
        name: 'Milagroso',
        skins: [{ src: `${emojisPath}miracle-worker.gif` }],
      },
      {
        id: 'mj',
        keywords: [],
        name: 'Michael Jackson',
        skins: [{ src: `${emojisPath}mj.gif` }],
      },
      {
        id: 'mo',
        keywords: [],
        name: 'MO',
        skins: [{ src: `${emojisPath}mo.png` }],
      },
      {
        id: 'mo_clean',
        keywords: [],
        name: 'MO - Limpia',
        skins: [{ src: `${emojisPath}mo_clean.png` }],
      },
      {
        id: 'nelson',
        keywords: [],
        name: 'Nelson',
        skins: [{ src: `${emojisPath}nelson.png` }],
      },
      {
        id: 'nerd1',
        keywords: [],
        name: 'Nerd',
        skins: [{ src: `${emojisPath}nerd1.gif` }],
      },
      {
        id: 'no-this',
        keywords: [],
        name: 'Eso no',
        skins: [{ src: `${emojisPath}no-this.png` }],
      },
      {
        id: 'nobattery',
        keywords: [],
        name: 'Sin batería',
        skins: [{ src: `${emojisPath}nobattery.png` }],
      },
      {
        id: 'omg-onoz',
        keywords: [],
        name: 'OMG ONOZ',
        skins: [{ src: `${emojisPath}omg-onoz.gif` }],
      },
      {
        id: 'omgomgomg',
        keywords: [],
        name: 'OMG OMG OMG',
        skins: [{ src: `${emojisPath}omgomgomg.gif` }],
      },
      {
        id: 'omgsocute',
        keywords: [],
        name: 'OMG - Tierno',
        skins: [{ src: `${emojisPath}omgsocute.png` }],
      },
      {
        id: 'oscar',
        keywords: [],
        name: 'Oscar',
        skins: [{ src: `${emojisPath}oscar.png` }],
      },
      {
        id: 'paddlin',
        keywords: [],
        name: 'Tabla',
        skins: [{ src: `${emojisPath}paddlin.png` }],
      },
      {
        id: 'pandaomg',
        keywords: [],
        name: 'Panda - OMG',
        skins: [{ src: `${emojisPath}pandaomg.gif` }],
      },
      {
        id: 'pandashake',
        keywords: [],
        name: 'Panda - Sacude',
        skins: [{ src: `${emojisPath}pandashake.gif` }],
      },
      {
        id: 'panicfry',
        keywords: [],
        name: 'Fray - Pánico',
        skins: [{ src: `${emojisPath}panicfry.gif` }],
      },
      {
        id: 'party-parrot',
        keywords: [],
        name: 'Loro - Fiesta',
        skins: [{ src: `${emojisPath}party-parrot.gif` }],
      },
      {
        id: 'pffff',
        keywords: [],
        name: 'Pfff',
        skins: [{ src: `${emojisPath}pffff.png` }],
      },
      {
        id: 'pika_dance',
        keywords: [],
        name: 'Pikachu - Baila',
        skins: [{ src: `${emojisPath}pika_dance.gif` }],
      },
      {
        id: 'pinky',
        keywords: [],
        name: 'Pinky',
        skins: [{ src: `${emojisPath}pinky.png` }],
      },
      {
        id: 'pinocchio',
        keywords: [],
        name: 'Pinocho',
        skins: [{ src: `${emojisPath}pinocchio.png` }],
      },
      {
        id: 'please',
        keywords: [],
        name: 'Por favor',
        skins: [{ src: `${emojisPath}please.png` }],
      },
      {
        id: 'plusone',
        keywords: ['uno'],
        name: 'Más 1',
        skins: [{ src: `${emojisPath}plusone.png` }],
      },
      {
        id: 'plusthree',
        keywords: ['tres'],
        name: 'Más 3',
        skins: [{ src: `${emojisPath}plusthree.png` }],
      },
      {
        id: 'plustwo',
        keywords: ['dos'],
        name: 'Más 2',
        skins: [{ src: `${emojisPath}plustwo.png` }],
      },
      {
        id: 'pokeball',
        keywords: [],
        name: 'Pokebola',
        skins: [{ src: `${emojisPath}pokeball.gif` }],
      },
      {
        id: 'poor',
        keywords: [],
        name: 'Pobre',
        skins: [{ src: `${emojisPath}poor.png` }],
      },
      {
        id: 'professor',
        keywords: [],
        name: 'Profesor',
        skins: [{ src: `${emojisPath}professor.jpg` }],
      },
      {
        id: 'pug',
        keywords: [],
        name: 'Pug',
        skins: [{ src: `${emojisPath}pug.gif` }],
      },

      {
        id: 'ramon',
        keywords: [],
        name: 'Don Ramón',
        skins: [{ src: `${emojisPath}ramon.png` }],
      },
      {
        id: 'success_kid',
        keywords: ['success', 'kid', 'niño', 'triunfo'],
        name: 'Success Kid',
        skins: [{ src: `${emojisPath}success_kid.png` }],
      },
      {
        id: 'sweatbits',
        keywords: ['sweatbits', 'sb', 'swb'],
        name: 'SweatBits',
        skins: [{ src: `${emojisPath}sb.png` }],
      },
      {
        id: 'troll',
        keywords: ['troll', 'ja'],
        name: 'Troll',
        skins: [{ src: `${emojisPath}troll.png` }],
      },
      {
        id: 'tronco',
        keywords: ['tronco'],
        name: 'Tronco',
        skins: [{ src: `${emojisPath}tronco.png` }],
      },
      {
        id: 'walking_dead',
        keywords: ['walking', 'dead', 'wd', 'twd'],
        name: 'Walking Dead',
        skins: [{ src: `${emojisPath}zombie.gif` }],
      },
    ],
    name: 'Comunidad',
  },
] as const

export default CUSTOM_EMOJIS
